(() => {
  const button = document.querySelector('.mb-menu-toggle');
  const menu = document.getElementById('mb-mobile-nav');
  function closeMenu() {
    if (!button || !menu) return;
    button.setAttribute('aria-expanded','false');
    button.setAttribute('aria-label','Menu openen');
    menu.hidden = true;
  }
  if (button && menu) {
    button.addEventListener('click', () => {
      const currentlyOpen = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!currentlyOpen));
      button.setAttribute('aria-label', currentlyOpen ? 'Menu openen' : 'Menu sluiten');
      menu.hidden = currentlyOpen;
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    window.addEventListener('resize', () => { if (window.innerWidth > 860) closeMenu(); });
  }
})();
